import {Pipe,PipeTransform} from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  'name':'mydate'
})
export class MyDatePipe implements PipeTransform{

  transform(value){
    if(value!=null){
      var s=value;
      if(s.indexOf("AM")!=-1){
        value=s.replace("AM"," AM");
      }
      if(s.indexOf("PM")!=-1){
        value=s.replace("PM"," PM");
      }


      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(new Date(value).toDateString(), 'd MMM, y');
      return value;
    }

  }

  tolocalDateTime(today) {
    var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
    var hours = today.getHours() ;
    var AmOrPm = hours >= 12 ? 'pm' : 'am';
    hours = (hours % 12) || 12;
    var minutes = today.getMinutes();
    var sec = today.getSeconds();
    var finalTime = date+ " " + hours + ":" + minutes + ":" + sec + " " + AmOrPm; 
    return finalTime;
  }

}

@Pipe({
  'name':'discount'
})
export class CalDiscount implements PipeTransform {

  transform(value){
    if(value!=null){
      var d = + localStorage.getItem('discount')
      var NewAmount = value-(value*(d/100)); 
      //only two decimal after value
      // var res = NewAmount.toFixed(2);
      var res = NewAmount.toFixed(0);
      return res;      
    }
  }  

}




// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/my-date.pipe.ts